import { gql } from 'apollo-angular';

export class NexusUserQueries {
  public static getNexusUser = gql`
    query GetNexusUser($username: String!) {
      nexusUser(username: $username) {
        returnValue
      }
    }
  `;
}
